module.exports = __webpack_public_path__ + "img/banner-header-new_02-administracion-de-riesgos.1a67728f.jpg";